<template>
	<main id="app-main">
		<router-view v-slot="{ Component }">
			<permission-route :filter-parent-routes="parentRoutesName">
				<transition name="fade" mode="out-in" appear>
					<component :is="Component" />
				</transition>
			</permission-route>
		</router-view>
		
	</main>
	
</template>
<script setup>
import PermissionRoute from '@/components/PermissionRoute.vue'

import { onBeforeMount,ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useSelector } from '@/utils/hooks'

const store = useStore()
const route = useRoute()

const parentRoutesName = ref(['subscribe','website','websites','overview','promotions','invitations','notices','notices-detail','promotions detail','personal center',"setings"])

/* 第三方登录跳转utl含token，携带token请求用户信息 */
const handleTokenLogin = async () => {
	console.log('handleTokenLogin')
	const params = {
		token: route.query.token,
	}
	
	await store.dispatch('user/tokenLoginAction',params)
}

onBeforeMount(async () => {
	const token = useSelector(state => state.user.userInfo?.token)

	if (!token.value && route.query?.token) {
		await handleTokenLogin()
	}
})
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
